export const CPT_MODIFIERS_BEGIN = "CPT_MODIFIERS_BEGIN";
export type CPT_MODIFIERS_BEGIN = typeof CPT_MODIFIERS_BEGIN;

export const CPT_MODIFIERS_COMPLETED = "CPT_MODIFIERS_COMPLETED";
export type CPT_MODIFIERS_COMPLETED = typeof CPT_MODIFIERS_COMPLETED;

export const CPT_MODIFIERS_ERROR = "CPT_MODIFIERS_ERROR";
export type CPT_MODIFIERS_ERROR = typeof CPT_MODIFIERS_ERROR;

export const CPT_MODIFIERS_CLEAN = "CPT_MODIFIERS_CLEAN";
export type CPT_MODIFIERS_CLEAN = typeof CPT_MODIFIERS_CLEAN;
